module.exports = __webpack_public_path__ + "static/media/certificate_for_the_use_of_green_mark_16124.c583c863.png";